import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { SpinnerShort } from '../models/spinner';
import { filter } from 'rxjs/operators';
import { SPINNER_DEFAULT_SETTINGS } from '../constants';

@Injectable({
  providedIn: 'root',
})
export class SpinnerService {
  private spinnerObservable = new BehaviorSubject(
    new SpinnerShort({
      name: SPINNER_DEFAULT_SETTINGS.SPINNER_NAME,
      show: false,
    })
  );
  private spinnersCount = 0;

  constructor() {}

  getSpinner(name: string): Observable<SpinnerShort> {
    return this.spinnerObservable
      .asObservable()
      .pipe(filter((x: SpinnerShort) => x && x.name === name));
  }

  show(name: string = SPINNER_DEFAULT_SETTINGS.SPINNER_NAME) {
    if (!this.spinnersCount) {
      this.spinnerObservable.next(new SpinnerShort({ name, show: true }));
    }
    this.spinnersCount++;
  }

  hide(name: string = SPINNER_DEFAULT_SETTINGS.SPINNER_NAME) {
    if (this.spinnersCount) {
      this.spinnersCount--;
      if (!this.spinnersCount) {
        this.spinnerObservable.next(new SpinnerShort({ name, show: false }));
      }
    }
  }
}
